import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Heures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: Math.floor(Math.random() * 3),
      random: Math.floor(Math.random() * 9) + 1,
      minuteTab: ["30", "20", "15", "12", "10", "6", "5", "4", "3", "2"],
      fractionTab: [
        "1/2",
        "1/3",
        "1/4",
        "1/5",
        "1/6",
        "1/10",
        "1/12",
        "1/15",
        "1/20",
        "1/30",
      ],
      decimalTab: [
        "0.5",
        "0.33",
        "0.25",
        "0.2",
        "0.16",
        "0.1",
        "0.08",
        "0.06",
        "0.05",
        "0.03",
      ],
      answer: "",
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerMinutes = (event) => {
    event.preventDefault();

    if (
      this.state.answer === this.state.fractionTab[this.state.random] ||
      this.state.answer === this.state.decimalTab[this.state.random]
    ) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.minuteTab[this.state.random] +
          " min = " +
          this.state.answer +
          "h",
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.minuteTab[this.state.random] +
          " min = " +
          this.state.fractionTab[this.state.random] +
          "h ou " +
          this.state.decimalTab[this.state.random] +
          "h",
      });
    }
    var que = Math.floor(Math.random() * 3);
    var rand = Math.floor(Math.random() * 9) + 1;
    this.setState({ random: rand, question: que, answer: ""  });
  };

  mySubmitHandlerDecimal = (event) => {
    event.preventDefault();
    if (this.state.answer === this.state.minuteTab[this.state.random]) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.decimalTab[this.state.random] +
          "h = " +
          this.state.answer +
          " min",
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.decimalTab[this.state.random] +
          "h = " +
          this.state.minuteTab[this.state.random] +
          " min",
      });
    }
    var que = Math.floor(Math.random() * 3);
    var rand = Math.floor(Math.random() * 9) + 1;
    this.setState({ random: rand, question: que, answer: "" });
  };

  mySubmitHandlerFraction = (event) => {
    event.preventDefault();
    if (this.state.answer === this.state.minuteTab[this.state.random]) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.fractionTab[this.state.random] +
          "h = " +
          this.state.answer +
          " min",
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.fractionTab[this.state.random] +
          "h = " +
          this.state.minuteTab[this.state.random] +
          " min",
      });
    }
    var que = Math.floor(Math.random() * 3);
    var rand = Math.floor(Math.random() * 9) + 1;
    this.setState({ random: rand, question: que, answer: "" });
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  render() {
    // Si question == 1 alors le carré sera posé
    if (this.state.question === 0) {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Conversion heures</h2>
            </div>
          </div>

          <div className="container">
            <p>
              Les questions peuvent être posées dans les 2 sens. De minutes vers
              décimals/fractions et de fractions/décimals vers minutes.
            </p>
            <p>
              Pour la conversion des minutes, les fractions (ex : "1/10") ou les
              décimals (ex : "0.1") sont acceptées.
            </p>
            <p>Répondre dans les unités.</p>
            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerMinutes}
            >
              <div className="row">
                <label className="label-exos">
                  {this.state.minuteTab[this.state.random]} min = ?
                </label>
              </div>
              <input
                className="input-square"
                type="text"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>
        </div>
      );
    } else if (this.state.question === 1) {
      // Sinon le décimal sera posé
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Conversion heures</h2>
            </div>
          </div>

          <div className="container">
            <p>
              Les questions peuvent être posées dans les 2 sens. De minutes vers
              décimals/fractions et de fractions/décimals vers minutes.
            </p>
            <p>
              Pour la conversion des minutes, les fractions (ex : "1/10") ou les
              décimals (ex : "0.1") sont acceptées.
            </p>
            <p>Répondre dans les unités.</p>
            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerDecimal}
            >
              <div className="row">
                <label className="label-exos">
                  {this.state.decimalTab[this.state.random]}h = ?
                </label>
              </div>
              <input
                className="input-square"
                type="text"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>
        </div>
      );
    } else if (this.state.question === 2) {
      // Sinon la fraction sera posé
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Conversion heures</h2>
            </div>
          </div>

          <div className="container">
            <p>
              Les questions peuvent être posées dans les 2 sens. De minutes vers
              décimals/fractions et de fractions/décimals vers minutes.
            </p>
            <p>
              Pour la conversion des minutes, les fractions (ex : "1/10") ou les
              décimals (ex : "0.1") sont acceptées.
            </p>
            <p>Répondre dans les unités.</p>
            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerFraction}
            >
              <div className="row">
                <label className="label-exos">
                  {this.state.fractionTab[this.state.random]}h = ?
                </label>
              </div>
              <input
                className="input-square"
                type="text"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Heures;
